export const toasts = (state) => state.toast.toasts || [];
